var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"target":"_blank","href":_vm.url,"title":_vm.value}},[_vm._t("value"),_vm._v("\n  "+_vm._s(_vm.shortener(_vm.value))+"\n")],2)}
var staticRenderFns = []

export { render, staticRenderFns }